export default __webpack_public_path__ + "static/media/plus-icon.b70d7dec.svg";